import { SYS_SPACE_FIXED_300 } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';

export const StyledContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 28px;
`;

export const StyledDialogSection = styled.section`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_300};

	.features {
		color: ${({ theme }) => theme.sys.color.text.headline.default};
	}
`;
